package org.moxultimate.topwithmox.utils

/**
 * toTitleCase
 * Capitalises the first letter of each space-separated word, leaving remaining letters unchanged.
 * Ensures lookup-table entries (tags, types, series) are stored consistently as Title Case.
 */
fun String.toTitleCase(): String =
    split(" ").joinToString(" ") { word -> word.replaceFirstChar { it.uppercase() } }

/**
 * autoTagSync
 * Ensures [newValue] (Title-Cased) is present in the pipe-separated [tags] string,
 * replacing [oldValue] if present.
 * Used by CRUD form pages to keep the tags field in sync with title and type fields automatically.
 *
 * @param tags     Current pipe-separated tag string from the form.
 * @param oldValue Previous value of the field that changed (removed from tags if present).
 * @param newValue New value of the field (prepended to tags if not already present).
 * @return Updated pipe-separated tag string with Title Case values.
 */
fun autoTagSync(tags: String, oldValue: String, newValue: String): String {
    val parts = tags.split("|")
        .map { it.trim() }
        .filter { it.isNotBlank() }
        .toMutableList()
    if (oldValue.isNotBlank()) parts.remove(oldValue.trim().toTitleCase())
    val trimmed = newValue.trim().toTitleCase()
    if (trimmed.isNotBlank() && !parts.contains(trimmed)) parts.add(0, trimmed)
    return parts.joinToString(" | ")
}
